import React, { useState, useEffect } from "react";
import styled from "styled-components/macro";
import {
  PrimaryButton,
  SecondaryButton,
  ButtonSizeOptions,
  InputText
} from "@loanbossinc/component-library";
import {
  FormControl,
  Select,
  MenuItem
} from "@material-ui/core";

import { CAMPAIGN_TYPES } from "../dashboard/constants";

const Root = styled.div`
  font-family: Work Sans;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1em;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: Work Sans;
  flex: 1;
  padding: 6px 0 30px 0;
  gap: 1em;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  font-family: Work Sans;
  gap: 1em;
`;

const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

const StyledSelect = styled(Select)`
  font-family: 'Work Sans' !important;
  font-weight: 400;
  border-radius: 8px 8px 0 0;
  height: 50px;
  background-color: #F0F0F0;
  div {
      padding: 8px;
      background: rgba(0, 0, 0, 0) !important;
  }
`;

const StyledMenuItem = styled(MenuItem)`&&& {
  font-family: 'Work Sans';
  height: 37px;
}`;

export const NewCampaign = ({ setNewCampaignFlag, onCreate, onCancel, campaignTypes, setSelectedCampaignTypeForCreation }) => {
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [customCampaignName, setCustomCampaignName] = useState("");

  useEffect(() => {
    setSelectedCampaign(campaignTypes?.find(campaign => campaign.id === CAMPAIGN_TYPES.PREPAYMENT.id)?.id);
  }, [campaignTypes]);

  const handleCreateCampaignClicked = () => {
    setSelectedCampaignTypeForCreation(selectedCampaign);
    onCreate(customCampaignName, selectedCampaign);
    setNewCampaignFlag(true);
  };

  const isValid = () => customCampaignName && selectedCampaign;

  return (
    <Root>
      <Body>
        <StyledFormControl>
          <StyledSelect
            onChange={selectedItem => setSelectedCampaign(selectedItem.target.value)}
            value={selectedCampaign}
          >
            {campaignTypes.map(({ id, value }) => <StyledMenuItem key={id} value={id}>{value}</StyledMenuItem>)}
          </StyledSelect>
        </StyledFormControl>
        <InputText
          variant="standard"
          placeholder="Name of Campaign here"
          label="Campaign Name *"
          name="campaignName"
          type="text"
          onChange={e => setCustomCampaignName(e.target.value)}
          value={customCampaignName}
        />
      </Body>
      <Footer>
        <SecondaryButton
          label="Cancel"
          size={ButtonSizeOptions.smFluid}
          style={{ width: 132 }}
          onClick={onCancel}
        />
        <PrimaryButton
          label="Create"
          disabled={!isValid()}
          size={ButtonSizeOptions.smFluid}
          onClick={handleCreateCampaignClicked}
          style={{ width: 132 }}
        />
      </Footer>
    </Root>
  );
};

export default NewCampaign;
